import { createIcon } from '@chakra-ui/react';

export const PlayIcon = createIcon({
	viewBox: '0 0 13 16',
	d: 'M0 13.3367V2.66333C0 1.081 1.75049 0.125317 3.08152 0.980975L11.383 6.31764C12.6076 7.10492 12.6076 8.89508 11.383 9.68236L3.08152 15.019C1.75049 15.8747 0 14.919 0 13.3367Z',
});
